module.exports = __webpack_public_path__ + "img/ch16_07_被困铁室.1d4f5ce7.jpg";